
import { Component, Vue, Prop } from 'vue-property-decorator'
import { namespace, State } from 'vuex-class'
import { signUpWithReferrerUrl } from 'bits/location'
import OzContainedButton, {
  OzContainedButtonColorScheme,
  OzContainedButtonSizePreset,
} from 'library/v4/components/OzContainedButton.vue'
import OzAvatar from 'library/v4/components/OzAvatar.vue'
import type { User, Wall } from 'types'
import { isRegistered } from 'bits/user_model'

@Component({
  components: { OzContainedButton, OzAvatar },
})
export default class AppBarAccountAvatar extends Vue {
  @Prop({ required: true }) user!: User
  @Prop({ default: 'auto' }) darkMode!: boolean | 'auto'

  @State wall!: Wall
  @namespace('appBarAccount').Action showUserMenu!: () => void
  OzContainedButtonColorScheme = OzContainedButtonColorScheme
  OzContainedButtonSizePreset = OzContainedButtonSizePreset

  get isUserRegistered(): boolean {
    return isRegistered(this.user)
  }

  get avatarSize(): number {
    return 24
  }

  get signUpUrl(): string {
    return signUpWithReferrerUrl(this.wall.links.show)
  }
}
